// a semi random A/B test generator function, depending on visitor id
export const getABTestVariant = (value: string): "A" | "B" =>
  value
    .replace(/-/g, "")
    .split("")
    .map((val) => parseInt(val, 16))
    .reduce((acc, curr) => acc + curr, 0) % 2
    ? "A"
    : "B";
